import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom.scss';

const LOGO_SRC = `${process.env.PUBLIC_URL}/main_logo.png`;

function UnderConstructionPage() {
    return (
        <div id="root">
            <main className="main-container under-construction-page">
                <Container className="custom-container under-construction-container py-4 px-3 px-md-4">
                    <div className="under-construction text-center">
                        <img
                            src={LOGO_SRC}
                            alt="teachers-app.com"
                            className="app-logo-img under-construction-logo"
                        />
                        <h2 className="mb-3">Αναβάθμιση σε εξέλιξη</h2>
                        <p className="mb-3">
                            Ανανεώνουμε τα δεδομένα και ετοιμάζουμε νέες λειτουργίες που θα κάνουν την εμπειρία σας
                            στο <strong>teachers-app.com</strong> ακόμα πιο χρήσιμη.
                        </p>
                        <p className="text-muted mb-0">
                            Σας ευχαριστούμε για την υπομονή σας. Η εφαρμογή θα είναι εκ νέου διαθέσιμη στις{' '}
                            <strong>21/06</strong>, με αναβαθμίσεις και νέες δυνατότητες.
                        </p>
                        <p className="text-muted mb-0 mt-3 under-construction-contact">
                            Επικοινωνία:{' '}
                            <a href="mailto:support@teachers-app.com" className="text-decoration-none under-construction-email">
                                <strong>support@teachers-app.com</strong>
                            </a>
                        </p>
                    </div>
                </Container>
            </main>
        </div>
    );
}

export default UnderConstructionPage;
